import React from 'react';
import '../constants/AssetsCss';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
import withRouter from '../constants/withRouter';

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.updatePosition = this.updatePosition.bind(this);
        this.positionChanged = this.positionChanged.bind(this);
        this.onWithdrawClicked = this.onWithdrawClicked.bind(this);
        this.state = {
            username: "",
            availablecompanywallet: "0",
            availablePaywallet: "0",
            leftteamtotalmember: 0,
            rightteamtotalmember: 0,
            teamtotalmember: 0,
            leftteamactivemember: 0,
            rightteamactivemember: 0,
            totalactivemember: 0,
            businessleft: "0.00",
            businessright: "0.00",
            totalbusiness: "0.00",
            totalpackage: "0.00",
            directsposnorbonus: "0.00",
            matchingbonus: "0.00",
            levelbonus: "0.00",
            totalbonus: "0.00",
            Affiliatelink: "https://viyanxo.com/office/#/register/",
            total_direct_sponsor_count: "0",
            active_direct_sponsor_count: "0",
            Announcement: "",
            selfInvestmentTable: "",
            activepackage: "0",
            completedpackage: "0",
            position: "",
            currenttab: "staking",
            samStakings: [],
            samWithdrawals: [],
            samLogins: [],
            received: 0
        };
    }
    componentDidMount() {
        this.getDashboardDetails();
        //this.getSelfInvestments();
    }
    async getDashboardDetails() {
        let res = await GetORPostAsync("GetDashboardDetails.asp", "GET", null, localStorage.getItem("token"));
        if (res.status === "error" && res.message === "Session Expired") {
            toast(res.message);
            this.props.history.push({
                pathname: "/"
            });
            return;
        }
        this.setState(res);
        this.setState({
            Affiliatelink: "https://viyanxo.com/office/#/register/" + localStorage.getItem("username"),
            samStakings: res.Staking,
            samLogins: res.login,
            samWithdrawals: res.Withdraw
        })
        localStorage.setItem("username", res.username);
    }
    async updatePosition() {
        let josn = {
            pos: this.state.position
        }
        let res = await GetORPostAsync("updatepos.asp", "POST", JSON.stringify(josn), localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            return;
        }
        toast(res.message);
    }
    positionChanged(event) {
        this.setState({ position: event.target.value });
    }
    async onWithdrawClicked() {
        this.props.history.push({
            pathname: "/home/withdraw"
        });
    }

    render() {
        return (<div>
            <div className="page-header">
                <div className="page-leftheader" style={{ width: '100%' }}>
                    <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                    {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>Dashboard</label></li>
                </ol> */}
                    <marquee className="page-title mb-0 fs-14">
                        {this.state.Announcement}
                    </marquee>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-3 col-md-12 " style={{ marginBottom: "1.45rem" }}>
                    <div className="card" style={{ height: "100%", backgroundColor: "#1e1e1e" }}>
                        <div className="card-body">
                            <h3 className=" mb-2 mt-2">Activation Wallet</h3>
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <h4 className="mb-0"><span className="number-font1">{this.state.availablecompanywallet}</span></h4>
                                </div>
                                <span className="text-color-3 fs-35  bg-white-transparent border-color-1 dash1-iocns"><i className="las la-wallet"></i></span>
                            </div>
                        </div>
                        {/* <Link className="" to='/home/deposit'>
                            <div className="d-flex mb-5 ml-5 mr-5 ">
                                <button className="btn  border-color-1 bg-color-1 text-white" style={{ width: "100%" }}>Deposit </button>
                            </div>
                        </Link> */}
                        <Link className="" to={{ pathname: '/home/ctransfer/company', state: { isCompanyWallet: true } }}>
                            <div className="d-flex mb-5 ml-5 mr-5 ">
                                <button className="btn  border-color-4 bg-color-4 text-white" style={{ width: "100%" }}>Transfer </button>
                            </div>
                        </Link>

                        <Link className="" to={{ pathname: '/home/transactions/company', state: { isCompanyWallet: true } }}>
                            <div className="d-flex mb-5 ml-5 mr-5 ">
                                <button className="btn  border-color-3 bg-color-3 text-white" style={{ width: "100%" }}>Transactions </button>
                            </div>
                        </Link>
                    </div>
                </div>
                <div className="col-xl-6 col-md-12 p-0">
                    <div className="d-flex flex-wrap " style={{ color: "white", padding: "0px" }}>
                        <div className="col-xl-6 col-md-12 ">
                            <div className="card ">
                                <div className="card-body">
                                    <div className="d-flex align-items-end justify-content-between">
                                        <div>
                                            <p className=" mb-1 fs-14">Total Team</p>
                                            <h3 className="mb-0"><span className="number-font1">{this.state.teamtotalmember}</span></h3>
                                        </div>
                                        <span className="text-color-3 fs-35  bg-white-transparent border-color-1 dash1-iocns"><i className="las la-users"></i></span>
                                    </div>
                                    <div className="d-flex mt-4">
                                        <div>
                                            <span className="fs-15 mr-1">Left</span>
                                            <span className="number-font fs-17"><i className="fa fa-caret-left mr-1 text-white"></i><br />{this.state.leftteamtotalmember}</span>
                                        </div>
                                        <div className="ml-auto">
                                            <span className="fs-15 mr-1">Right</span>
                                            <span className="number-font fs-17"><i className="fa fa-caret-right mr-1 text-white"></i><br />{this.state.rightteamtotalmember}</span>
                                        </div>
                                    </div>
                                    <div className="d-flex mt-2">
                                        <Link className="text-color-prime ml-auto mr-auto" to={{ pathname: '/home/teamlist', state: { isActiveTeam: false } }}> <span className="mt-1  badge " style={{ backgroundColor: "white" }}>View Details</span></Link>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-end justify-content-between">
                                        <div>
                                            <p className=" mb-1 fs-14">Active Team</p>
                                            <h3 className="mb-0"><span className="number-font1">{this.state.totalactivemember}</span></h3>
                                        </div>
                                        <span className="text-color-3 fs-35  bg-white-transparent border-color-1 dash1-iocns"><i className="las la-user-check"></i></span>

                                    </div>
                                    <div className="d-flex mt-4">
                                        <div>
                                            <span className="fs-15 mr-1">Left</span>
                                            <span className="number-font fs-17"><i className="fa fa-caret-left mr-1 text-white"></i><br />{this.state.leftteamactivemember}</span>
                                        </div>
                                        <div className="ml-auto">
                                            <span className="fs-15 mr-1">Right</span>
                                            <span className="number-font fs-17"><i className="fa fa-caret-right mr-1 text-white"></i><br />{this.state.rightteamactivemember}</span>
                                        </div>
                                    </div>
                                    <div className="d-flex mt-2">
                                        <Link className="ml-auto mr-auto" to={{ pathname: '/home/teamlist', state: { isActiveTeam: true } }}><span className="mt-1 badge text-color-2" style={{ backgroundColor: "white" }}>View Details</span></Link>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className=" col-xl-6 col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-end justify-content-between">
                                        <div>
                                            <p className=" mb-1 fs-14">Business</p>
                                            <h3 className="mb-0"><span className="number-font1">{this.state.totalbusiness}</span></h3>
                                        </div>
                                        <span className="text-color-3 fs-35  bg-white-transparent border-color-1 dash1-iocns"><i className="las la-hand-holding-usd"></i></span>
                                    </div>
                                    <div className="d-flex mt-4">
                                        <div>
                                            <span className="fs-15 mr-1">Left</span>
                                            <span className="number-font fs-17"><i className="fa fa-caret-left mr-1 text-white"></i><br />{this.state.businessleft}</span>
                                        </div>
                                        <div className="ml-auto">
                                            <span className="fs-15 mr-1">Right</span>
                                            <span className="number-font fs-17"><i className="fa fa-caret-right mr-1 text-white"></i><br />{this.state.businessright}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className=" col-xl-6 col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-end justify-content-between">
                                        <div>
                                            <p className=" mb-1 fs-14">Package</p>
                                            <h3 className="mb-0"><span className="number-font1">{this.state.totalpackage}</span></h3>
                                        </div>
                                        <span className="text-color-3 fs-35  bg-white-transparent border-color-1 dash1-iocns"><i className="las la-thumbs-up"></i></span>
                                    </div>
                                    <div className="d-flex mt-4">
                                        <div>
                                            <span className="fs-15 mr-1">Active</span>
                                            <span className="number-font fs-17"><i className="fa fa-caret-left mr-1 text-white"></i><br />{this.state.activepackage}</span>
                                        </div>
                                        <div className="ml-auto">
                                            <span className="fs-15 mr-1">Completed</span>
                                            <span className="number-font fs-17"><i className="fa fa-caret-right mr-1 text-white"></i><br />{this.state.completedpackage}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-md-12" style={{ marginBottom: "1.45rem" }}>
                    <div className="card" style={{ height: "100%", backgroundColor: "#1e1e1e" }}>
                        <div className="card-body">
                            <h3 className=" mb-2 mt-2">Payout Wallet</h3>
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <h4 className="mb-2 mt-2"><span className="number-font1">{this.state.availablePaywallet}</span></h4>
                                    {/* <h4 className="mb-0"><span className="number-font1">Received : {this.state.received}</span></h4> */}
                                </div>
                                <span className="text-color-3 fs-35  bg-white-transparent border-color-1 dash1-iocns"><i className="las la-wallet"></i></span>
                            </div>
                        </div>
                        <div className="">
                            <div className="d-flex mb-5 ml-5 mr-5 ">
                                <button className="btn  border-color-1 bg-color-1 text-white" onClick={this.onWithdrawClicked} style={{ width: "100%" }}>Withdraw </button>
                            </div>
                        </div>
                        {/* <Link className="" to={{ pathname: '/home/ctransfer/cash', state: { isCompanyWallet: false } }}>
                            <div className="d-flex mb-5 ml-5 mr-5 ">
                                <button className="btn border-color-4 bg-color-4 text-white" style={{ width: "100%" }}>Transfer </button>
                            </div>
                        </Link> */}

                        <Link className="" to={{ pathname: '/home/transactions/cash', state: { isCompanyWallet: false } }}>
                            <div className="d-flex mb-5 ml-5 mr-5 ">
                                <button className="btn border-color-3 bg-color-3 text-white" style={{ width: "100%" }}>Transactions </button>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="card mb-1 overflow-hidden dash1-card border-0">
                        <div className="card-body text-center">
                            <h4>ViyanXO Millionaire's Club</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-3 col-md-12">
                    <div className="card overflow-hidden dash1-card border-0">
                        <div className="card-body text-center">
                            <p className=" mb-1 ">Sponsor Bonus</p>
                            <h5 className="number-font mb-2" style={{ marginTop: "5px" }}>{this.state.directsposnorbonus}</h5>
                            <Link to='/home/sponsorbonus'><button style={{ color: "white" }} className="btn bg-color-3"><i className="fe fe-eye mr-1"></i>View Bonus</button></Link>
                        </div>
                    </div>
                </div>
                <div className={"col-lg-3 col-md-12"}>
                    <div className={"card overflow-hidden dash1-card border-0"}>
                        <div className="card-body text-center">
                            <p className=" mb-1 ">Level Bonus</p>
                            <h5 className="number-font mb-2" style={{ marginTop: "5px" }}>{this.state.level}</h5>
                            <Link to='/home/levelbonus'><button style={{ color: "white" }} className="btn bg-color-1"><i className="fe fe-eye mr-1"></i>View Bonus</button></Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body text-center">
                            <p className=" mb-1 ">Matching Bonus</p>
                            <h5 className="number-font mb-2" style={{ marginTop: "5px" }}>{this.state.matchingbonus}</h5>
                            <Link to='/home/matchbonus'><button style={{ color: "white" }} className="btn bg-color-7"><i className="fe fe-eye mr-1"></i>View Bonus</button></Link>
                        </div>
                    </div>
                </div>

                <div className="col-lg-3 col-md-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body text-center">
                            <p className=" mb-1">Total Bonus</p>
                            <h5 className="number-font mb-2" style={{ marginTop: "5px" }}>{this.state.totalbonus}</h5>
                            <Link to='/home/bonusstatement'><button style={{ color: "white" }} className="btn bg-color-4"><i className="fe fe-eye mr-1"></i>View Bonus</button></Link>

                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className=" col-lg-12 col-md-12">
                    <div className="card overflow-hidden dash1-card border-0">
                        <div className="card-body">
                            <h5 className="mb-3">How do I get more affiliate bonus?</h5>
                            <div className='d-flex align-items-center'>
                                <div style={{ flex: 1 }} className="search-element">
                                    <div className="input-container mr-0 mb-0 align-items-center">
                                        <i className="las la-link inputicon"></i>
                                        <input type="search" className="input-field form-control" placeholder="Affiliate link" aria-label="Affiliate link" value={this.state.Affiliatelink} tabIndex="1" readOnly />
                                    </div>
                                </div>
                                <CopyToClipboard text={this.state.Affiliatelink}><button className="ml-2 btn btn-color-1" onClick={() => toast("Affiliate link copied")}>Copy</button></CopyToClipboard>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="card ">
                        <ul class="nav nav-pills mb-3 mt-3" id="pills-tab" role="tablist">
                            <li class="nav-item col col-sm-4" role="presentation">
                                <Link to='#' onClick={(e) => {
                                    this.setState({
                                        currenttab: 'staking'
                                    })
                                }} class={`nav-link  ${this.state.currenttab === 'staking' ? 'bg-warning' : 'bg-dark'}`} id="pills-home-tab" data-toggle="pill" role="tab" aria-controls="pills-home" aria-selected="false">Staking(s)</Link>
                            </li>
                            <li class="nav-item col col-sm-4" role="presentation">
                                <Link to='#' onClick={(e) => {
                                    this.setState({
                                        currenttab: 'withdrawals'
                                    })
                                }} class={`nav-link   ${this.state.currenttab === 'withdrawals' ? 'bg-warning' : 'bg-dark'}`} id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Withdrawal(s)</Link>
                            </li>
                            <li class="nav-item  col col-sm-4" role="presentation">
                                <Link to='#' onClick={(e) => {
                                    this.setState({
                                        currenttab: 'logins'
                                    })
                                }} class={`nav-link ${this.state.currenttab === 'logins' ? 'bg-warning' : 'bg-dark'} `} id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="true">Login(s)</Link>
                            </li>
                        </ul>
                        <div className="card-body" style={{ display: this.state.currenttab === 'staking' ? "block" : "none", borderTop: '1px solid #ebecf1' }}>
                            <div className="table-responsive">
                                <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Package</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.samStakings.length > 0 ? this.state.samStakings.map((e, i) => (
                                                <tr key={i}><td class="bg-color-1 text-white">{(i + 1)}</td><td>{e.CreatedDate}</td><td>{e.package}</td><td>{e.packageclose ? "Completed" : "Active"}</td></tr>
                                            )) : <tr><td colSpan='5'>No Records</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card-body" style={{ display: this.state.currenttab === 'withdrawals' ? "block" : "none" }}>
                            <div className="table-responsive">
                                <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.samWithdrawals.length > 0 ? this.state.samWithdrawals.map((e, i) => (
                                                <tr key={i}><td class="bg-color-1 text-white">{(i + 1)}</td><td>{e.widthdrawaldate}</td><td>{e.amount}</td><td>{e.status}</td></tr>
                                            )) : <tr><td colSpan='4'>No Records</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card-body" style={{ display: this.state.currenttab === 'logins' ? "block" : "none" }}>
                            <div className="table-responsive">
                                <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>IP</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.samLogins.length > 0 ? this.state.samLogins.map((e, i) => (
                                                <tr key={i}><td class="bg-color-1 text-white">{(i + 1)}</td><td>{e.cdate}</td><td>{e.ip}</td></tr>
                                            )) : <tr><td colSpan='3'>No Records</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default withRouter(Dashboard);